import { payment_receipt } from "./html.templates";

export const files = [
  {
    name: "Pago recibido + Factura",
    code: "payment_receipt",
    html: payment_receipt,
  },
];


